import React, {Component} from 'react';
import { connect } from "react-redux";
import {Row, Col, Button, Fa} from "mdbreact";
import {Link} from "react-router-dom";
import {API_URL, IMAGE_URL} from "../../config/Config";
import axios from "axios/index";
import SweetAlert from 'sweetalert2-react';
import SaveLoader from "../loader/SaveLoader";
import axiosRetry from 'axios-retry';

axiosRetry(axios, { retries: 3 });

class Product extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:true,
            isSave:false,
            type:'success',
            title:'خرید شما با موفقیت ثبت شد'
        };
    }

    async buyFreeCart(id){
        this.setState({loading: false});
        try {
            let response = await axios.get(`${API_URL}cart-buy/${id}?api_token=${this.props.user.apiToken}`);
            // let order = await response.data.data;
            let status = await response.data.status;
            await this.setState({loading:false});
            if (status === "success"){
                this.setState({
                    isSave:true,
                    type:'success',
                    title:'خرید شما با موفقیت ثبت شد'
                });
            }else{
                this.setState({isSave:true});
                this.setState({
                    isSave:true,
                    type:'error',
                    title: "خطایی در هنگام ثبت درخواست شما رخ داد"
                });
            }


        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                await this.setState({loading: true});
                this.setState({
                    isSave:true,
                    type:'error',
                    title: statusText
                });
            }
        }
        this.setState({loading: true});
    }



    render() {
        const { productObj } = this.props;

        return (
            <div className="product-list-item mb-5">
                <Row>
                    <div className="d-flex justify-content-start w-100 pl-5" style={{borderTop:"1px solid #a5a5a5"}}>
                        {(productObj.has_offer === '1') ? <div><div className="text-white  primary-color-dark product-item-lables">پیشنهاد ویژه</div></div>: ""}
                        {productObj.discount_amount !==0 ? <div><div className="text-white danger-color-dark product-item-lables">{productObj.discount_amount} ریال تخفیف </div></div>: ""}

                        <div className="ml-auto p-2 text-center" >
                                <p><span className="oldPrice ng-binding">{productObj.price_org} ریال<span className="cross-price" style={{backgroundColor: "#0092cf"}}/></span></p>
                                <p><span className="newPrice"><span className="price ng-binding">{productObj.price}</span> <span className="currancy"> ریال</span> </span></p>
                        </div>
                    </div>
                </Row>
                <Row>
                    <Col sm="12" md="4" >
                        <Link to={"/product/"+productObj.id} className="product-title">
                            <img src={IMAGE_URL+productObj.image_url} alt={productObj.title} className="w-100"/>
                        </Link>
                    </Col>
                    <Col sm="12" md="8" className='pt-5'>
                        <h2 className="mt-5"><Link to={"/product/"+productObj.id} className="product-title">{productObj.title}</Link></h2>
                        <p className="text-justify mt-3">{productObj.short_desc}</p>
                        <Row className="mt-5">
                            <Col md="6" sm="12"/>
                            <Col md="6" sm="12" className="text-center">
                                {(this.props.user.apiToken === null)?
                                <Link to={`login`} className="btn btn-outline-info btn-block Ripple-parent product-add-to-cart"><Fa icon="shopping-cart" className="mr-1"/> خرید {productObj.price} ریال</Link>
                                :
                                    <div>
                                    {(productObj.price === "0") ?
                                        <Button onClick={this.buyFreeCart.bind(this,productObj.id)} outline block  color="info" className="product-add-to-cart"> خرید {productObj.price} ریال</Button>
                                        :
                                        <a className="btn btn-outline-info btn-block Ripple-parent product-add-to-cart"
                                           href={`${API_URL}cart/buy/${productObj.id}?api_token=${this.props.user.apiToken}`}
                                           target='_blank'>خرید و فعال سازی ({productObj.price} تومان)</a>
                                    }
                                    </div>
                                }

                                <br/>

                                <Link to={`product/${productObj.id}`} className="product-title"><Fa icon="search" className="mr-1"/> مشاهده جزئیات </Link>

                            </Col>
                        </Row>
                    </Col>
                </Row>

                {!this.state.loading ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}
                <SweetAlert
                    show={this.state.isSave}
                    title={this.state.title}
                    type={this.state.type}
                    showConfirmButton={true}
                />
            </div>


        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps, null)(Product);


// WEBPACK FOOTER //
// ./src/components/product/Product.js